'use client';

import { usePathname } from 'next/navigation';

import BackButton from '../../components/ui/BackButton';

import styles from './destination.module.scss';

/**
 * Адаптивен бутон „Назад“ за споделената рамка на дестинация/корица.
 * Стои в layout-а и НЕ се пре-рендира при навигация между дестинация и корица —
 * само преизчислява целта/текста според текущия път (usePathname).
 * - На страница корица (`/destinations/[slug]/[templateId]`) → назад към дестинацията.
 * - На страница дестинация (`/destinations/[slug]`) → назад към колекцията.
 */
export default function DestinationFrameBack({ slug, destinationName, collectionName }) {
  const pathname = usePathname();
  // ['destinations', slug] → дестинация; ['destinations', slug, templateId] → корица
  const segments = (pathname || '').split('/').filter(Boolean);
  const onCoverPage = segments.length >= 3;

  let href;
  let label;
  if (onCoverPage) {
    href = `/destinations/${encodeURIComponent(slug)}`;
    label = `Назад към ${destinationName}`;
  } else if (collectionName) {
    href = `/collections/${encodeURIComponent(collectionName)}`;
    label = `Назад към ${collectionName}`;
  } else {
    href = '/collections';
    label = 'Назад към колекции';
  }

  return (
    <div className={styles.backButtonWrap}>
      <BackButton href={href}>{label}</BackButton>
    </div>
  );
}
